import { ApplicationStatus } from '@/apis/family_application/requests'
import { useGetPayments } from '@/apis/payments/hooks/useGetPayments'
import { Card, CardHeader } from '@/app/common/components/Card'
import PageLoader from '@/app/common/components/PageLoader/PageLoader'
import SearchInput from '@/app/common/components/SearchInput'
import { usePagination } from '@/app/common/hooks/usePagination'
import { selectFamilyApplication } from '@/storage/applications/familyApplicationSlice'
import { selectProgramID } from '@/storage/program_settings/programSettingsSlice'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import PaymentsTable from './payments-table'

export type IPayment = {
  id: number
  transaction_no: string
  student_name: string
  type: string
  provider: string
  category: string
  status: ApplicationStatus
}

export default function PaymentsPage() {
  const application = useSelector(selectFamilyApplication)
  const programId = useSelector(selectProgramID)
  const { t } = useTranslation()
  const {
    currentPage,
    perPage,
    setCurrentPage,
    setPerPage,
    debouncedValue,
    onSearchChange,
    search,
  } = usePagination()

  const query = useGetPayments({
    applicant_id: application.applicant_id,
    page: currentPage,
    per_page: perPage,
    program_id: programId,
    search: debouncedValue,
  })

  return (
    <>
      <Card>
        <CardHeader>
          <div className="flex justify-between items-center">
            <h2 className="font-medium">{t('pending_payments')}</h2>
            <SearchInput
              id="table_search"
              placeholder="Search Payments"
              value={search}
              onChange={(e) => onSearchChange(e.target.value)}
            />
          </div>
        </CardHeader>
        <PageLoader query={query}>
          {(data) => {
            return (
              <PaymentsTable
                currentPage={currentPage}
                recordsPerPage={perPage}
                totalRecords={data.total}
                payments={data.data}
                onPageChange={setCurrentPage}
                onPerPageChange={setPerPage}
              />
            )
          }}
        </PageLoader>
      </Card>
    </>
  )
}
